import { useQuery } from "@apollo/client";

import { GqlMapEditorGetLayerAllFeaturesParams } from "~/__generated__/graphql/graphql";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { ProjectReviewVisitV2Screen_GetDataDocument } from "./queries.generated";

export default function useProjectReviewVisitV2Screen_GetData(
    projectId: string,
    visitId: string,
    mapParams: GqlMapEditorGetLayerAllFeaturesParams,
) {
    const { data, loading, error, previousData } = useQuery(ProjectReviewVisitV2Screen_GetDataDocument, {
        variables: { projectId, visitId, projectIdString: projectId, params: mapParams },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const result = data ?? previousData;
    const [filterOptions] = useCacheFilterOptions(result?.plannerVisitGetAllMapEditorLayerFeatures?.filterOptions);

    return {
        projectData: result?.projectGetById,
        researchTypes: result?.projectGetResearchTypesById,
        mapData: result?.plannerVisitGetAllMapEditorLayerFeatures?.data,
        observationTypes: result?.projectGetObservationTypesById,
        layerData: result?.mapEditorLayerGetAll?.data,
        filterOptions,
        visit: result?.plannerV2VisitGetById,
        loading,
        error,
    };
}
